export const FPJS_CONTEXT = Symbol('FPJS_CLIENT');
